import styled from 'styled-components';
import { white } from 'sushiweb/tokens/color';
import green from 'sushiweb/tokens/color/green';
import red from 'sushiweb/tokens/color/red';

export const TableHeaderWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
  height: 3rem;
  padding: 0px 0px 20px 0px;
  h5 {
    font-family: Lexend-400;
    font-weight: 400;
  }
  div {
    margin-top: -15px;
  }
`;

export const DebitsSectionHeaderWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
  height: 4.4rem;
  margin-top: 30px;
  h5 {
    font-family: Lexend-400;
    font-weight: 400;
  }
`;
export const CreditsWrapper = styled.span`
  color: ${green.z600};
  padding-right: 5px;
`;

export const DebitWrapper = styled.div`
  color: ${red.z500};
  padding-right: 5px;
`;

export const CheckoutBtnContainer = styled.div`
  position: fixed;
  width: calc(100vw - 27rem);
  bottom: 0;
  right: 0;
  height: 8rem;
  background: ${white};
  box-shadow: 10px 1px 10px rgba(125, 125, 125, 0.2);
  z-index: 10;
  display: flex;
  justify-content: right;
  align-items: center;

  @media (max-width: 480px) {
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }
`;

export const LoggedOutCheckoutBtnContainer = styled.div`
  position: fixed;
  width: calc(100vw);
  bottom: 0;
  right: 0;
  height: 8rem;
  background: ${white};
  box-shadow: 10px 1px 10px rgba(125, 125, 125, 0.2);
  z-index: 10;
  display: flex;
  justify-content: right;
  align-items: center;

  @media (max-width: 480px) {
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }
`;

export const ActionComponentWrapper = styled.div`
  display: flex;
`;

export const ActionComponentContainer = styled.div`
  display: flex;
  margin-top: -10px;
`;
